import { render, staticRenderFns } from "./AppraisalPage.vue?vue&type=template&id=c6bad844&scoped=true"
import script from "./AppraisalPage.vue?vue&type=script&lang=ts"
export * from "./AppraisalPage.vue?vue&type=script&lang=ts"
import style0 from "./AppraisalPage.vue?vue&type=style&index=0&id=c6bad844&prod&lang=scss"
import style1 from "./AppraisalPage.vue?vue&type=style&index=1&id=c6bad844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bad844",
  null
  
)

export default component.exports